
import { Placement } from '@post-office/placements-frontend/wac-product-activation-checklist';
export default Placement;
